import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  usePostUOMOrderMutation,
  useTotalUOMMutation,
} from "../../../../store/api/itemapi";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
// import SearchFilters from "../../../../Core/SearchFilters/SearchFilters";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ExportCSV from '../../../../Core/Export/ExportCSV'
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import {useDeleteDocMutation} from '../../../../store/api/globalapi'
import useScreenHeight from "../../../../utils/useScreenHeight";

const MainContent = () => {
  const navigate = useNavigate();
  const { screenHeight, screenScaling , pageSize} = useScreenHeight();

  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setCountItemData] = useState(0);
  const [purchaseData, setPurchaseData] = useState({
    purchase_order: [],
    total_no_of_records: 0,
  });
  const [uomDataApi] = usePostUOMOrderMutation();
  const [totalitemCountApi] = useTotalUOMMutation();
  const [showColumnConfig, setShowColumnConfig] = useState(false);
  const [showExportPopup, setShowExportPopup] = useState(false);

  const doctype = "UOM";
	const [deleteDoc] = useDeleteDocMutation();
	const [delPopupVisible, setDelPopupVisible] = useState(false);
	const [delSelectedId, setDelSelectedId] = useState(null);
	const [delmessage, setDelmessage] = useState();
	const [alreadySubmitData, setAlreadySubmitData] = useState(false);
  const [delDone, setDelDone] = useState(false);
  
  const filtersConfig = [
    { name: "siNo", label: "S. No", width: "3.8%", type: 'number' },
    { name: "uom_name", label: "Id", width: "37.7%", type: 'text' },
    { name: "uom_name", label: "UOM Name", width: "37.7%", type: 'text' },
    {
      name: "enabled",
      label: "Status",
      width: "12.7%",
      type: "select",
      options: [
        { value: "1", label: "Enabled" },
        { value: "0", label: "Disabled" },
      ],
    },
  ];

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };
  const handleView = (id) => {
    try {
      navigate(`/master/uom/view-uom/`, { state: { ItemId: id } });
    } catch (err) {
      console.error("Edit failed:", err);
    }
  };
  const handleEdit = async (id) => {
    try {
      navigate(`/master/uom/edit-uom/`, { state: { ItemId: id } });
    } catch (err) {
      console.error("Edit failed:", err);
    }
  };
  const handleDelete = (id) => {
		setDelSelectedId(id);
		setDelPopupVisible(true);
		setAlreadySubmitData(false);
		setDelmessage(`Are you sure you want to Delete this ${doctype}?`);
	};

	const delHandleCancel = () => {
		setDelPopupVisible(false);
		setDelSelectedId(null);
	};

	const delHandleConfirm = async () => {
		try {
			await deleteDoc({
				doctype: doctype,
				name: delSelectedId,
			}).unwrap();
			setDelmessage(`${doctype} ${delSelectedId} deleted successfully!`);
			setDelDone(true);
			setTimeout(() => {
				setDelPopupVisible(false);
				setDelSelectedId(null);
				setDelDone(false);
				getData();
				getCountData();
			}, 1000);
		} catch (err) {
			console.error("Deletion Failed:", err);

			let errorMessage = "Failed to delete the Purchase Receipt!";

			//If the server is sending the error message , we will extract it.
			if (err?.data?._server_messages) {
				try {
					const messageArr = JSON.parse(err.data._server_messages);
					if (messageArr && messageArr.length > 0) {
						//parse inner json object
						const messageObj = JSON.parse(messageArr[0]);
						if (messageObj?.message) {
							//extract the exact message we want
							const fullMessage = messageObj.message;
							errorMessage = fullMessage.split("You must")[0].trim();
							//remove html in the message
							errorMessage = errorMessage.replace(/<[^>]+>/g, "");
						}
					}
				} catch (parseError) {
					console.error("Error parsing server messages:", parseError);
				}
			}
			setDelPopupVisible(true);
			setDelmessage(errorMessage);
			setAlreadySubmitData(true);
		} finally {
			// setTimeout(() => {
			//     setDelPopupVisible(false);
			//     setDelSelectedId(null);
			// }, 2000);
		}
	};

  const [columnsConfig, setColumnsConfig] = useState(() => [
    {
      header: "SI No.",
      name: "SI No.",
      accessor: "siNo",
      visible: true,
      width: "6%",
      sortable: false, // avoid enabling sort unless you manage it manually
      cellRenderer: (row) => row.siNo, // fallback also handled above
    },
    {
      header: "Id",
      name: "Id",
      accessor: "uom_name",
      visible: true,
      width: "27.7%",
      sortable: false,
    },
    {
      header: "UOM Name",
      name: "UOM Name",
      accessor: "uom_name",
      visible: true,
      width: "27.7%",
      sortable: false,
    },
    {
      header: "Status",
      name: "Status",
      accessor: "enabled",
      width: "12.7%",
      sortable: false,
      visible: true,
      cellRenderer: (row) => {
        const isDisabled = row.enabled === 0; // 0 = Disabled, 1 = Enabled
        const label = isDisabled ? "Disabled" : "Enabled";
        const color = isDisabled ? "#D97706" : "#6366F1"; // Orange for Disabled, Green for Enabled

        return <span style={{ color }}>{label}</span>;
      },
    },

    {
      header: "Action",
      accessor: "action",
      name: "Action",
      width: "0%",
      visible: true,
      sortable: false,
      cellRenderer: (row) => (
        <ActionButtonDropdown
          id={row.uom_name}
          onView={() => handleView(row.uom_name)}
          onEdit={() => handleEdit(row.uom_name)}
          onDelete={() => handleDelete(row.uom_name)}
        />
      ),
    },
  ]);

  // Handle column configuration changes
  const handleSaveColumns = (selectedKeys, allFields) => {
    const updatedColumns = columnsConfig.map(column => {
      return {
        ...column,
        visible: selectedKeys.includes(column.accessor)
      };
    });
    setColumnsConfig(updatedColumns);
  };

  const visibleColumns = useMemo(() =>
    columnsConfig.filter(col => col.visible === true),
    [columnsConfig]
  );

  const defaultSelectedColumns = useMemo(() =>
    columnsConfig
      .filter(col => col.visible === true)
      .map(col => ({
        fieldname: col.accessor,
        label: col.name
      }))
      .filter(col => col.fieldname),
    [columnsConfig]
  );
  const activeFilterCount = useMemo(() => {
    return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
  }, [filters]);


  const actionButtons = [
    {
      className: "createbtn border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "IoFilterSharp",
      iconSize: 12,
      children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
      onClick: () => {
        setShowFilters(prev => !prev);
        setShowColumnConfig(false);
      }
    },
    {
      className: "createbtn border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "MdOutlineRemoveRedEye",
      iconSize: 12,
      children: "Show more",
      onClick: () => {
        setShowColumnConfig(prev => !prev);
        setShowFilters(false);
      }
    },
    {
      className: "createbtn border-0 d-flex",
      style: { gap: "2px", height: "28px" },
      iconName: "RiFileExcel2Fill",
      iconSize: 12,
      children: "Export Excel",
      onClick: () => setShowExportPopup(true),
    },
    {
      className: "custom-btn-00989 d-flex",
      to: "/master/uom/create-uom",
      iconName: "FiPlus",
      style: { gap: "2px", height: "28px" },
      children: "Add UOM",
    },
  ];
  const getData = async () => {
		setLoading(true);

		try {
			// STEP 1: Clean filters
			const filteredSearchInput = Object.entries(filters).reduce(
				(acc, [key, value]) => {
					if (value !== "" && value !== undefined && value !== null) {
						acc[key] = value;
					}
					return acc;
				},
				{}
			);

			const siNoFilter = filteredSearchInput.siNo;
			const isSiNoFilterActive = siNoFilter !== undefined && siNoFilter !== "";

			// STEP 2: Remove siNo from API filter
			const frappeFilters = Object.entries(filteredSearchInput)
				.filter(([key]) => key !== "siNo")
				.map(([key, value]) => {
					return ["UOM", key, "like", `%${value}%`];
				});

			// STEP 3: If filtering by siNo, jump to that page
			const targetPage = isSiNoFilterActive
				? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
				: currentPage;

			const payload = {
				start: pageSize * (targetPage - 1),
				limit: pageSize,
				filters: frappeFilters,
				fields: ["enabled", "uom_name", "must_be_whole_number"],
			};

			const response = await uomDataApi(payload);
			const rawData = response.data.data;

			// STEP 4: Assign global serial numbers
			const numberedData = rawData.map((item, index) => ({
				...item,
				siNo: index + 1 + pageSize * (targetPage - 1),
			}));

			// STEP 5: If siNo is used, filter client-side
			const finalData = isSiNoFilterActive
				? numberedData.filter((item) => item.siNo === parseInt(siNoFilter, 10))
				: numberedData;

			setPurchaseData(finalData);

			// Optional: update currentPage to reflect jump
			if (isSiNoFilterActive) setCurrentPage(targetPage);
		} catch (error) {
			console.error("Error fetching uom:", error);
		} finally {
			setLoading(false);
		}
 };

 const getCountData = async () => {
		setLoading(true);
		try {
			const response = await totalitemCountApi();
			if (response?.data) {
				setCountItemData(response?.data);
				//   console.log('count:', response?.data);
			}
		} catch (error) {
			console.error("Error fetching uom count:", error);
		} finally {
			setLoading(false);
		}
 };

  useEffect(() => {
    if(pageSize > 0){
      getData();
      getCountData();
    }
	}, [currentPage,filters,uomDataApi,totalitemCountApi, pageSize,screenHeight, screenScaling]);

	const [showFilters, setShowFilters] = useState(false)

	const accessors = columnsConfig
		.filter(
			(column) => column.accessor !== "siNo" && column.accessor !== "action"
		)
		.map((column) => column.accessor);
  return (
		<div
			className="container-fluid d-flex flex-column "
			style={{ flexGrow: "1" }}
		>
			<Tabs />
			<ListLayout
				breadcrumbItems={[
					{ label: "UOM" },
					{ label: "UOM List", style: { color: "rgb(39, 11, 121)" } },
				]}
				actionButtons={actionButtons}
			>
				{showFilters && (
					<ListFilters
						filtersConfig={filtersConfig}
						onFilterChange={handleFilterChange}
						currentFilters={filters}
						setShowFilters={setShowFilters}
					/>
				)}
				{showColumnConfig && (
					<ConfigureColumnsNew
						show={showColumnConfig}
						onClose={() => setShowColumnConfig(false)}
						onSave={handleSaveColumns}
						docType="UOM"
						defaultSelected={defaultSelectedColumns}
						fieldsData={columnsConfig.map((col) => ({
							fieldname: col.accessor,
							label: col.name,
						}))}
						disabledFields={["siNo", "action", "uom_name", "enabled"]}
					/>
				)}

				<Table columns={visibleColumns} data={purchaseData} loading={loading} />

				<Pagination
					setCurrentPage={setCurrentPage}
					pageSize={pageSize}
					totalRecords={totalRecords.message}
					currentPage={currentPage}
					className="mt-2 pb-3"
				/>
				{delPopupVisible && (
					<DelConfirmPopup
						alredysubmitdata={alreadySubmitData}
						delSelectedId={delSelectedId}
						visible={delPopupVisible}
						message={delmessage}
						onConfirm={delHandleConfirm}
						onCancel={delHandleCancel}
						delDone={delDone}
					/>
				)}
				{showExportPopup && (
					<ExportCSV doctype={doctype} onClose={() => setShowExportPopup(false)} fieldsData={accessors}/>
				)}
			</ListLayout>
		</div>
	);
};

export default MainContent;
